import { defineTheme } from '../utils'

const textColor = 'text-white'
const maxWidth = 'mx-auto w-full max-w-xl'
const centerContent = 'flex flex-wrap items-center justify-center gap-2.5'
const sharedCard = 'w-full bg-white/80 px-3 py-1 text-black mt-2.5'
const softPanel = 'w-full p-8.75 text-center text-white border border-white'

const ducoMenuItem = {
  base: 'flex flex-col items-center gap-2',
  title: 'font-[base-900-sans] uppercase',
  description: 'mt-1',
  priceList: `${centerContent} -mt-1`,
  priceItem: 'flex flex-col gap-1 items-center font-open-sans text-base',
  icons: `mt-1 ${centerContent}`,
  label: sharedCard,
}

export const ducoJosper = defineTheme({
  allergiesList: {
    base: `${maxWidth} px-4 ${textColor}`,
    heading: 'mb-4 text-center font-[base-900-sans] text-xl uppercase',
    list: 'grid grid-cols-2 text-base gap-2 md:grid-cols-3',
    item: 'flex items-center gap-2',
    filterLink: 'text-white'
  },
  languageButton: {
    base: 'border border-white/70 bg-white/10 px-4 py-2 text-sm uppercase text-white transition hover:bg-white hover:text-[#2e2d2c]',
  },
  menuCategory: {
    base: 'grid w-full gap-6 border border-white px-3.75 py-4 text-center justify-center',
    title: 'mb-1 font-[base-900-sans] text-xl pb-4 uppercase after:mx-auto after:block after:h-8 after:w-60 after:bg-[url(/images/duco/duco_border.svg)] after:bg-contain after:bg-center after:bg-no-repeat',
    description: 'font-[skippy-sharp] text-white text-[22px]',
  },
  menuItem: {
    dinner: ducoMenuItem,
    drinks: ducoMenuItem,
  },
  menuSubCategory: {
    base: 'grid w-full gap-2 text-center',
    title: 'font-[base-900-sans] text-lg uppercase',
    description: 'font-[skippy-sharp] text-xl',
  },
  menuTextBlock: {
    base: `mx-auto ${softPanel}`,
    title: 'font-[base-900-sans] text-sm uppercase',
    description: 'text-sm',
  },
  menuTitleBlock: {
    title: 'text-center font-[bodedo] text-4xl uppercase md:text-5xl',
  },
  page: {
    menuSection: `${maxWidth} px-4 py-16 text-center ${textColor}`,
    menuHeading: 'mb-8 font-[bodedo] text-5xl uppercase',
    menuDescription: `mb-4 ${softPanel} text-sm`,
    menuGrid: `gap-5`,
  },
  themeLogo: {
    wrapper: 'mx-auto mt-5',
    image: 'w-50 h-30 object-contain max-w-60 bg-[url(/images/logos/duco.svg)] bg-contain bg-center bg-no-repeat',
  },
  filterBar: {
    bar: 'bg-white text-black',
    checkbox: ' accent-white',
    closeButton: 'bg-black text-primary hover:bg-black/60',
    masterItem: 'text-black',
    itemLabel: 'text-black',
    popoverTitle: 'text-black',
    popover: 'bg-primary',
    popoverHeader: 'bg-grey text-white',
  },
})
